import { render } from "./ActivateBanner.vue?vue&type=template&id=45479db2&scoped=true&ts=true"
import script from "./ActivateBanner.vue?vue&type=script&lang=ts"
export * from "./ActivateBanner.vue?vue&type=script&lang=ts"

import "./ActivateBanner.vue?vue&type=style&index=0&id=45479db2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45479db2"]])

export default __exports__